import React, { useContext } from "react";
import { Context } from "../../context";
import Spinner from "../layout/Spinner";
import Track from './Track'
import Footer from "../layout/Footer";

const Tracks = () => {
  const { trackList, heading } = useContext(Context);

  if (trackList === undefined || trackList.length === 0) {
    return <Spinner />;
  } else {
    return (
      <>
        <h3 className="text-center mb-4">{heading}</h3>
        <div className="row">
          {trackList.map(item => (
            <Track key={item.track.track_id} track={item.track} />
          ))}
        </div>
        <Footer/>
      </>
    );
  }
};

export default Tracks;
